import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getDivisionAdjustment } from "services/data.inventory.service";

const columns = [
  { label: "CustomerCode", id: "toCustomer" },
  { label: "SKU Code", id: "skuCode" },
  { label: "Adjusted Quantity", id: "transferQuantity" },
  { label: "UOM", id: "baseUOM" },
];

function DivisionTransferDrawer({ open, setOpen, sTransferRequest, setSTransferRequest }) {

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["division-adjustment-log", { sTransferRequest }],
    queryFn: () => getDivisionAdjustment(sTransferRequest),
    enabled: sTransferRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      const details = item.stockTransferDetails;
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Stock Adjustment Number : </b>
                {item.stockTransferNo}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Reason : </b>
                {item.reason}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={details} />
          </div>
        </>
      );
    },
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setSTransferRequest(null);
  };

  return (
    <Drawer width="1100px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default DivisionTransferDrawer;
